import React from 'react';

function LinkMenuPrimary({ idSection, name, closeMenu }) {
  const redirectSection = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.error(`Section with id "${id}" not found.`);
    }
    
    if (closeMenu) {
      closeMenu();
    }
  };
  
  return (
    <a onClick={(e) => redirectSection(e, idSection)} className="link-animate">
      {name}
    </a>
  );
}

export default LinkMenuPrimary;
